import React from 'react';

interface Props {
  height?: number;
  variant?: 'light' | 'dark';
}

export function OnPitchLogo({ height = 32, variant = 'light' }: Props) {
  // light = white text (for green sidebar), dark = dark text (for white backgrounds)
  const pitchColor = variant === 'light' ? '#FFFFFF' : '#1A1A1A';

  return (
    <svg viewBox="0 0 130 32" style={{ height, display: 'block' }}>
      <text x="0" y="24"
        fontFamily="'Barlow Condensed', sans-serif"
        fontSize="28"
        fontWeight="700"
        fill="#2D6A2D"
        letterSpacing="-0.5">ON</text>
      <text x="42" y="24"
        fontFamily="'Barlow Condensed', sans-serif"
        fontSize="28"
        fontWeight="400"
        fill={pitchColor}
        letterSpacing="-0.5">PITCH</text>
    </svg>
  );
}
